<template>
  <div class="p-4 overflow-hidden">
    <div class="pb-3">
      <h6 class="font-weight-bold">
        {{ current_cycle.date }}
      </h6>
      <div class="d-flex pb-1">
        <div class="divisor ml-1" />
        <div class="font-weight-bold py-0 pl-3">
          <div v-if="!current_cycle.is_finished">
            <p class="mb-0 font-14">
              Ciclo atual: {{ current_cycle.cycle_name }} 
            </p>
            <p class=" mb-0 font-14">
              {{ current_cycle.begin | moment('DD/MM/YYYY') }} - {{ current_cycle.end | moment('DD/MM/YYYY') }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <v-skeleton-loader
      v-show="isLoadingCalendar"
      type="list-item-three-line"
    />
    <div
      v-for="event in events"
      v-show="!isLoadingCalendar"
      :key="event.id"
      class="pb-3 "
      transition="fade-transition"
    >
      <p
        class="font-weight-bold h6 mb-1 font-14"
        :style="{ color: event.type === 'challenge' ? '#060181' : 'inherit' }"
      >
        <img 
          :src="event.type === 'challenge' ? '/images/icons/calendar_blue_icon.svg' : '/images/icons/calendar_gray_icon.svg'"
          class="calendar-icon"
        > {{ event.dateTitle }} 
      </p>
      <div class="d-flex pb-1">
        <div
          class="divisor ml-1"
          :class="{
            'bg-nitro': event.type === 'challenge'
          }"
        />
        <div
          class="font-weight-bold py-0 pl-3 "
        >
          <p
            class="mb-0 font-weight-semibold font-14"
            :style="{ color: event.type === 'challenge' ? '#060181' : 'inherit' }"
          >
            {{ event.title }}
          </p>
          <p
            v-if="event.type != 'cycle'"
            class="mb-0 font-weight-regular font-14"
            :style="{ color: event.type === 'challenge' ? '#060181' : 'inherit' }"
          >
            {{ event.description }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="current_cycle.is_finished && events.length == 0 && !isLoadingCalendar">
      <p class="font-14 font-weight-regular mb-0">
        Não há eventos nesta semana
      </p>
    </div>
  </div>
</template>
<script>

import {mapActions, mapGetters} from "vuex";

export default {
  props: {
    period: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(['current_cycle','events','isLoadingCalendar']),
  },
  mounted() {
      if(!this.isLoadingCalendar){
        this.getEvents(`&period=${this.period}`);
      }
  },
  methods: {
    ...mapActions(['getEvents'])
  }
}
</script>
<style scoped>
.divisor {
  width: 5px;
  border-radius: 5px;
  background-color: var(--gray-400);
}
.content {
  line-height: normal;
}
div {
  color: var(--gray-400);
}

</style>
